/**
 * API pour sofaxis-fonpel-espace-elus
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocalizedValueOfstring } from './localizedValueOfstring';
import { DataReference } from './dataReference';


export interface Check { 
    /**
     * Data references
     */
    dataReferences?: Array<DataReference>;
    /**
     * Document uid
     */
    documentUid?: string;
    errorCause?: LocalizedValueOfstring;
    /**
     * File uid
     */
    fileUid?: string;
    /**
     * Check identifier
     */
    identifier: string;
    /**
     * Complete message
     */
    message: string;
    /**
     * Check status
     */
    status: Check.StatusEnum;
    /**
     * Sub checks
     */
    subChecks?: Array<Check>;
    /**
     * Title
     */
    title: string;
    /**
     * Check type
     */
    type: Check.TypeEnum;
}
export namespace Check {
    export type StatusEnum = 'NONE' | 'OK' | 'WARN' | 'ERROR' | 'OBSOLETE';
    export const StatusEnum = {
        None: 'NONE' as StatusEnum,
        Ok: 'OK' as StatusEnum,
        Warn: 'WARN' as StatusEnum,
        Error: 'ERROR' as StatusEnum,
        Obsolete: 'OBSOLETE' as StatusEnum
    };
    export type TypeEnum = 'DOCUMENT_VALIDITY' | 'DOCUMENT_ACCEPTABILITY' | 'DATA_ACCEPTABILITY' | 'DATA_CONSISTENCY' | 'FILE_COMPLETENESS' | 'OTHER' | 'UNKNOWN';
    export const TypeEnum = {
        DocumentValidity: 'DOCUMENT_VALIDITY' as TypeEnum,
        DocumentAcceptability: 'DOCUMENT_ACCEPTABILITY' as TypeEnum,
        DataAcceptability: 'DATA_ACCEPTABILITY' as TypeEnum,
        DataConsistency: 'DATA_CONSISTENCY' as TypeEnum,
        FileCompleteness: 'FILE_COMPLETENESS' as TypeEnum,
        Other: 'OTHER' as TypeEnum,
        Unknown: 'UNKNOWN' as TypeEnum
    };
}


